// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddCustomerAddressMutation($input: AddCustomerAddressInput!) {
    addCustomerAddress(input: $input) {
      customer {
        id
        ...CustomerSidePanel_customer
        ...AddUpdateCustomerModal_customer
        ...AddUpdateOrderModal_customer
      }
      customerAddress {
        id
        label
        addressLine1
        addressLine2
        addressLine3
        addressCity
        addressState
        addressZip
        addressCountry
        isDefault
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
